module.exports = __webpack_public_path__ + "assets/images/kebab.ca6fb04a13cd8e359d2de99bf8baddff.svg";